import { Tooltip } from 'antd';
import { observer } from 'mobx-react-lite';
import { type ComponentProps } from 'react';

import { Logo } from '../../Logo/Logo';
import { ReactComponent as LogoWithSantaHat } from './LogoWithSantaHat.svg';

export const ChristmasLogo = observer(function ChristmasLogo(props: ComponentProps<typeof Logo>) {
	return (
		<Tooltip
			{...{
				title: 'Merry Christmas!',
				placement: 'right',
				children: <Logo {...{ children: <LogoWithSantaHat />, ...props }} />,
			}}
		/>
	);
});
